export default {
  XLARGE: '1.375rem',
  LARGE: '1.25rem',
  MEDIUM: '1rem',
  SMALL: '0.875rem',
  XSMALL: '0.75rem',
};